import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Bell, Sparkles, ArrowRight, Clock } from "lucide-react";

export default function WeeklyDigest() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/digest").then((r) => setD(r.data)).catch(()=>{}); }, []);

  if (!d) return null;

  const hasContent = d.total_active > 0 || d.resolved_this_week_count > 0;
  if (!hasContent) return null;

  return (
    <Card className="trust-card mb-6" data-testid="weekly-digest-card">
      <CardContent className="p-6">
        <div className="flex items-center gap-2 mb-4">
          <Sparkles className="w-5 h-5 text-[#1E3A8A]" />
          <h3 className="font-semibold text-slate-900">This week</h3>
        </div>

        <div className="grid grid-cols-3 gap-4 mb-5">
          <div className="text-center p-3 rounded-xl bg-slate-50 border border-slate-200">
            <p className="text-2xl font-bold text-slate-900" data-testid="digest-active-count">{d.total_active}</p>
            <p className="text-xs text-slate-500 mt-0.5">Active cases</p>
          </div>
          <div className="text-center p-3 rounded-xl bg-amber-50 border border-amber-200">
            <p className="text-2xl font-bold text-amber-800" data-testid="digest-overdue-count">{d.overdue?.length || 0}</p>
            <p className="text-xs text-amber-700 mt-0.5">Need action</p>
          </div>
          <div className="text-center p-3 rounded-xl bg-emerald-50 border border-emerald-200">
            <p className="text-2xl font-bold text-emerald-800" data-testid="digest-recovered-amount">${d.resolved_this_week_amount.toFixed(0)}</p>
            <p className="text-xs text-emerald-700 mt-0.5">Recovered · 7d</p>
          </div>
        </div>

        {d.overdue?.length > 0 && (
          <div className="mb-4">
            <p className="text-xs uppercase tracking-widest text-amber-700 font-semibold mb-2 flex items-center gap-1">
              <Bell className="w-3.5 h-3.5" /> Overdue
            </p>
            <div className="space-y-2">
              {d.overdue.map((c) => (
                <Link key={c.case_id} to={`/case/${c.case_id}`} className="flex items-center justify-between p-3 rounded-lg border border-amber-200 bg-amber-50/50 hover:bg-amber-50" data-testid={`digest-overdue-${c.case_id}`}>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-900 truncate">{c.merchant_name}</p>
                    <p className="text-xs text-amber-800">{c.next_step}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-amber-700 shrink-0" />
                </Link>
              ))}
            </div>
          </div>
        )}

        {d.active?.length > 0 && (
          <div>
            <p className="text-xs uppercase tracking-widest text-slate-500 font-semibold mb-2 flex items-center gap-1">
              <Clock className="w-3.5 h-3.5" /> Next steps
            </p>
            <div className="space-y-2">
              {d.active.slice(0, 3).map((c) => (
                <Link key={c.case_id} to={`/case/${c.case_id}`} className="flex items-center justify-between p-3 rounded-lg border border-slate-200 hover:border-[#93C5FD] hover:bg-slate-50" data-testid={`digest-active-${c.case_id}`}>
                  <div className="min-w-0">
                    <p className="text-sm font-semibold text-slate-900 truncate">{c.merchant_name}</p>
                    <p className="text-xs text-slate-500">{c.next_step}</p>
                  </div>
                  <ArrowRight className="w-4 h-4 text-slate-400 shrink-0" />
                </Link>
              ))}
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
